<rt-button
  #bulkActionsDropdownTrigger="rtOverlayOrigin"
  [disabled]="disabled"
  variant="default small"
  [dropdown]="true"
  rt-overlay-origin
  [ngClass]="{ 'is-first': active, dropdownOpened: state.dropdownOpened }"
  (click)="toggleDropdown()"
>
  <rt-checkbox
    [indeterminateState]="indeterminateState"
    [checked]="allSelected"
    (valueChange)="select.emit(!!$event)"
  >
    <span *ngIf="selectedCount > 0">{{ selectedCount }}</span>
  </rt-checkbox>
</rt-button>

<ng-template
  [open]="state.dropdownOpened"
  [origin]="bulkActionsDropdownTrigger"
  [rtConnectedOverlayPosition]="OverlayPosition.BottomLeft"
  (backdropClick)="toggleDropdown(false)"
  rt-connected-overlay
  [rtConnectedOverlayAutoClose]="false"
  [hasBackdrop]="true"
>
  <rt-dropdown>
    <rt-dropdown-item (click)="select.emit(true); toggleDropdown(false)">
      {{ 'rtu.common.bulk_select.all' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="select.emit(false); toggleDropdown(false)">
      {{ 'rtu.common.bulk_select.none' | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
